import { Dialog, DialogContent, Button } from '@mui/material';
import EditOperation from './EditOperation';
import DialogActionBar from './DialogActionBar';
import { validateOperationForm } from '../../../utils/operationValidation';

interface EditOperationModalProps {
  open: boolean;
  onClose: () => void;
  onSave: (formData: {
    title: string;
    agencyAssignedIdentifier: string;
    description: string;
    date: string;
    time: string;
    operationType: {
      planned: boolean;
      emergency: boolean;
    };
  }) => Promise<void>;
  formData: {
    title: string;
    agencyAssignedIdentifier: string;
    description: string;
    date: string;
    time: string;
    operationType: {
      planned: boolean;
      emergency: boolean;
    };
  };
  onFormDataChange: (updater: (prev: any) => any) => void;
  onValidationError?: (errors: string[]) => void;
  loading?: boolean;
}

export default function EditOperationModal({
  open,
  onClose,
  onSave,
  formData,
  onFormDataChange,
  onValidationError,
  loading = false
}: EditOperationModalProps) {
  const isFormValid = () => {
    const errors = validateOperationForm(formData, undefined, { includeLocations: false });
    return errors.length === 0;
  };

  const handleSave = async () => {
    // Validate form data (excluding locations)
    const validationErrors = validateOperationForm(formData, undefined, { includeLocations: false });
    
    if (validationErrors.length > 0) {
      if (onValidationError) {
        onValidationError(validationErrors);
      }
      return;
    }
    
    // If validation passes, call the parent save handler
    try {
      await onSave(formData);
    } catch (error) {
      // Error handling is delegated to the parent component
      console.error('Save failed:', error);
    }
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      sx={{
        '& .MuiDialog-paper': {
          borderRadius: 2,
          width: '783px',
          maxWidth: '783px',
          height: 'auto',
          maxHeight: '90vh',
          pt: 4,
          px: 3,
          pb: 2
        },
      }}
    >
      <DialogContent sx={{ p: 0, mb: 3 }}>
        <EditOperation
          title="Edit Operation Details"
          formData={formData}
          onFormDataChange={onFormDataChange}
          backgroundColor='common/white_states/main'
        />
      </DialogContent>

      <DialogActionBar>
        <Button onClick={onClose} variant="outlined" size="medium">
          Cancel
        </Button>
        <Button 
          onClick={handleSave} 
          variant="contained" 
          size="medium"
          disabled={loading || !isFormValid()}
        >
          {loading ? 'Saving...' : 'Save'}
        </Button>
      </DialogActionBar>
    </Dialog>
  );
}